import * as React from 'react';
import { archivedEntitiesProvider } from '../data/providers/archivedEntitiesProvider';
import {
  entitiesProvider,
  IEntities,
} from '../data/providers/entitiesProvider';
import { IAthlete, IGroup, ITeam } from '../data/types';

interface IUseEntities {
  athletes: IAthlete[];
  teams: ITeam[];
  groups: IGroup[];
  loading: boolean;
}

export const useEntities = (archived?: string): IUseEntities => {
  const [athletes, setAthletes] = React.useState<IAthlete[]>([]);
  const [teams, setTeams] = React.useState<ITeam[]>([]);
  const [groups, setGroups] = React.useState<IGroup[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  /**
   * @description subscribe to entities
   */
  if (archived === 'archived') {
    React.useEffect((): (() => void) => {
      const subscriber = archivedEntitiesProvider().subscribe(
        (entities: IEntities): void => {
          setAthletes(entities.athletes);
          setTeams(entities.teams);
          setGroups(entities.groups);
          setLoading(false);
        }
      );
      return (): void => subscriber.unsubscribe();
    }, []);
  } else {
    React.useEffect((): (() => void) => {
      const subscriber = entitiesProvider().subscribe(
        (entities: IEntities): void => {
          setAthletes(entities.athletes);
          setTeams(entities.teams);
          setGroups(entities.groups);
          setLoading(false);
        }
      );
      return (): void => subscriber.unsubscribe();
    }, []);
  }

  return {
    athletes,
    teams,
    groups,
    loading,
  };
};
